import PropTypes from 'prop-types';

import Switch from 'shopper/components/Switch';

import placeholder from 'lib/placeholder';

const SubscriptionSwitch = ({ isSubscribed = false, onSubscribe, ...rest }) => (
  <Switch
    checked={isSubscribed}
    className="mb-3 md:mb-0"
    label={placeholder('switches.receiveNotificationsAlertShort')}
    size="size2"
    onClick={onSubscribe}
    {...rest}
  />
);

SubscriptionSwitch.propTypes = {
  isSubscribed: PropTypes.bool,
  onSubscribe: PropTypes.func.isRequired,
};

export default SubscriptionSwitch;
